import React, { useEffect } from "react";
import {
  useGame,
  startAnotherRound,
  prepareRound,
  prepareRevealAbility,
} from "context/GameContext";
import { Abilities, RoundState } from "context/interfaces/GameContextInterface";
// Comps
import { IonPage } from "@ionic/react";
import Container from "components/common/Container/Container";
import Modal from "components/pages/Game/Board/Modal/Modal";
import RestartGame from "components/pages/Game/Board/RestartGame/RestartGame";
import Logo from "components/pages/Game/Board/Logo/Logo";
import ElectionTracker from "components/pages/Game/Board/ElectionTracker/ElectionTracker";
import LiberalBoard from "components/pages/Game/Board/LiberalBoard/LiberalBoard";
import FascistBoard from "components/pages/Game/Board/FascistBoard/FascistBoard";
import Policy from "components/pages/Game/Board/Policy/Policy";
import Players from "components/pages/Game/Board/Players/Players";
// Css
import classes from "./Board.module.scss";

const Board: React.FC = () => {
  const [{ roundState, activeAbility }, gameDispatch] = useGame();

  useEffect(() => {
    prepareRound(gameDispatch);
  }, [gameDispatch]);

  useEffect(() => {
    switch (roundState) {
      case RoundState.AbilityActive:
        if (activeAbility === Abilities.Reveal)
          prepareRevealAbility(gameDispatch);
        break;
      case RoundState.GameFinished:
        break;
      case RoundState.WaitToStartAnotherRound:
        startAnotherRound(gameDispatch);
        break;
      default:
        break;
    }
  }, [activeAbility, gameDispatch, roundState]);

  return (
    <IonPage>
      <Container className={classes.container} hasBackBtn={false}>
        <Modal />
        {roundState === RoundState.GameFinished && <RestartGame />}
        <Logo maxWidth="110px" />
        <ElectionTracker />
        <LiberalBoard />
        <FascistBoard />
        <Policy />
        <Players />
      </Container>
    </IonPage>
  );
};

export default Board;
